<n-panel height="100%">
    <div id="virtual-machine-console-main-div">
        <div id="virtual-machine-console-menu-div" class="vnc-menu">
            <button id="virtual-machine-console-logout-btn" 
                class="logout-btn"
                nButton 
                [label]="str.i18n.sendCtrlAltDelLab"
                (click)="sendCtrlAltDel()">
            </button>
        </div>
        <div #virtualMachineConsoleContainer
            id="virtual-machine-console-container" 
            class="vnc-container">
        </div>
    </div>
</n-panel>